import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { useDashboardPieType } from "../../types";
import { EmployeeCostToRevenueResponse } from "../../types/EmployeeCostToRevenueResponse";

export const useEmployeeCostToRevenue = ({ date, location_id }: useDashboardPieType) => {
  const api = useApi();
  const [data, setData] = useState<EmployeeCostToRevenueResponse | null>(null);

  const params: Record<string, string | number> = {
    year_month: date,
    ...(location_id && { location_id }),
  };

  const fetchData = () => {
    api.get("/dasboard_inventory/employee-cost-to_revenue", { params })
    .then((res: SuccessFetch<{ payload: EmployeeCostToRevenueResponse }>) => {
      const payload = res.data.payload;
      setData(payload);
    })
    .catch(() => setData(null));
  };

  useEffect(() => {
    fetchData();
    return () => setData(null);

    // eslint-disable-next-line
  }, [date, location_id]);

    return { fetchData, data };
}
